/**
 * Route: /
 */
import NavbarFive from "../components/Common/NavbarFive";
import MainBanner from "../components/Home/MainBanner";
import FeaturedService from "../components/Home/FeaturedService";
import OurMission from "../components/Home/OurMission";
import BestService from "../components/Home/BestService";
import Footer from "../components/Common/Footer";
import GoTop from "../components/Common/GoTop";
import { useSelector } from "react-redux";
import Preloader from "../components/Common/Preloader";
import { Box, Typography, Button, Container } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

const Index = () => {
  const isLoading = useSelector((state) => state.pageContents?.loading); // Loading state from Redux

  return (
    <>
      <NavbarFive />
      <MainBanner />
      <FeaturedService />
      <Box
        component="section"
        sx={{
          borderTop: "2px solid",
          borderBottom: "1px solid",
          borderColor: "primary.main",
          py: 3,
          textAlign: "center",
          mt: -1, // Slight overlap with banner for visual appeal
        }}
      >
        <Container maxWidth="lg">
          <Typography variant="h5" sx={{ mb: 2, fontWeight: "bold" }}>
            Important Statement from SMFA
          </Typography>
          <Typography
            variant="body1"
            sx={{ mb: 2, maxWidth: "sm", mx: "auto" }}
          >
            Read our latest statement on the use of acetaminophen during fetal
            surgery.
          </Typography>
          <Button
            component={RouterLink}
            to="/news/acetaminophen-fetal-surgery"
            variant="contained"
            color="secondary"
            size="large"
            sx={{ textTransform: "none", px: 4 }}
          >
            Read the Statement
          </Button>
        </Container>
      </Box>
      {/* Add important news item here */}
      <OurMission />
      {/* <UpcomingCampaign /> */}
      {/* <NewsStyleOne /> */}
      {/* <DoctorsStyleThree /> */}
      {/* <AboutUs /> */}
      <BestService />
      {/* <AppointmentForm /> */}
      {/* <Subscribe /> */}
      <Footer />
      {isLoading ? <Preloader /> : null}
      <GoTop scrollStepInPx="100" delayInMs="10.50" />
    </>
  );
};

export default Index;
